export enum Classification {
    REGULATION = 'REGULATION',
    RISK_ASSESSMENT_SUPPLIER = 'RISK_ASSESSMENT_SUPPLIER'
}
